import React from 'react'
import qrCodeImage from './QR-Code-img.png'
import transparentBg from './transparent-bg.png'
import css from './preview.module.scss'

const Preview = ({ color, transparent }: { color: string; transparent?: boolean }) => {
  return (
    <React.Fragment>
      <label className={`${css.label} text-grey-1000-70`}>Preview</label>
      <div
        className={css.container}
        style={{
          border: `2px solid ${color}`,
          ...(transparent
            ? { backgroundImage: `url("${transparentBg}")`, backgroundSize: 'cover' }
            : {}),
        }}
      >
        <div
          className={css.title}
          style={{
            backgroundColor: color,
          }}
        >
          <span style={{ color: '#FFFFFF' }}>NEIGHBORHOOD DESK</span>
        </div>
        <div className={css.code}>CA-SMBP-3420-3</div>
        <div className={css.description}>
          2342 South Point du Sable Lake Shore Drive, 10th floor
        </div>
        <img className={css.styled_img} width="65" height="65" src={qrCodeImage} alt="QR-code" />
      </div>
    </React.Fragment>
  )
}

export default Preview
